import React, { useEffect } from "react";

import { Swiper } from "antd-mobile-v5";

import modStyl from './index.module.scss'
import poster1 from '../../assets/images/ban1.jpg'
import poster2 from '../../assets/images/ban2.jpg'

export default function Banner() {
  const props = {
    dragging: false,
    autoplay: true,
    dotStyle: {
      width: 5,
      height: 5,
      borderRadius: 8,
      background: 'rgba(255,255,255,.5)'
    },
    dotActiveStyle: {
      width: 12,
      height: 5,
      background: '#fff',
      borderRadius: 8
    }
  }

  const posters = [
    {
      key: 1,
      href: '',
      poster: poster1,
    },
    {
      key: 2,
      href: 'https://hmez.huimeihealth.com.cn/hm/scrm/hmlymobile/cd/1739111231323824128?aid=4_tid=5',
      poster: poster2,
    }
  ]

  const [ selectedIndex, setSelectedIndex ] = React.useState(0)
  useEffect(()=> {
    setSelectedIndex(0)
  }, [])
  return (
    <Swiper  className={modStyl.wrapper}>
      {
        posters.map(({poster, href, key}) => (
          <Swiper.Item key={key} className={modStyl.slide}>
            <img src={poster} alt=""/>
          </Swiper.Item>
        ))
      }
    </Swiper>
  )
}